const TRACK_SECTION = "TRACK_SECTION";
const TRACK_CLICK = "TRACK_CLICK";
const TRACK_SLIDER = "TRACK_SLIDER";

export const trackSection = section => ({
  type: TRACK_SECTION,
  meta: {
    analytics: {
      name: section,
      section: section,
      title: section
    }
  }
});

export const trackClick = (section, id) => ({
  type: TRACK_CLICK,
  meta: {
    analytics: {
      name: `${section}.click.${id}`,
      section: section,
      title: id,
    }
  }
})

export const trackSlider = (id, value) => ({
  type: TRACK_SLIDER,
  meta: {
    analytics: {
      name: `opkomst.${id}`,
      section: 'opkomst',
      title: value,
    }
  }
})



// WEBPACK FOOTER //
// ./src/services/analytics/actions.js